import Builder, { initialValues as builderInitialValues } from './Builder';
import Player from './Player';

export default {
    handle: 'statesTable',
    label: 'Reporting States Table',
    builderInitialValues,
    builder: Builder,
    player: Player,
};
